export interface RoleColor {
  bg: string;
  color: string;
}

/** 角色标签配色（后端 FrameworkRole 角色名 -> 颜色），不区分内部/外部 */
export const ROLE_COLORS: Record<string, RoleColor> = {
  Staff:   { bg: "rgba(100,116,139,0.08)",  color: "#64748b" },
  CRA:     { bg: "rgba(16,120,80,0.08)",    color: "#107850" },
  CSM:     { bg: "rgba(30,80,160,0.08)",    color: "#1e50a0" },
  Manager: { bg: "rgba(120,60,140,0.08)",   color: "#7a3c8a" },
  Admin:   { bg: "rgba(234,179,8,0.10)",    color: "#a16207" },
  Auditor: { bg: "rgba(140,80,0,0.08)",     color: "#7a4500" },
};

/** 获取角色配色，未知角色回退到灰色 */
export const getRoleColor = (role: string): RoleColor =>
  ROLE_COLORS[role] ?? { bg: "rgba(156,163,175,0.15)", color: "#6b7280" };

/** 角色展示排序：按首字母（不区分大小写） */
export const sortRoles = (roles: string[]): string[] =>
  [...roles].sort((a, b) => a.localeCompare(b));

/** 角色权限说明（标签 tooltip 用） */
export const rolePermissionMap: Record<string, string> = {
  Staff: "Ask module · View only · No source docs",
  CRA: "Ask + MVR modules",
  CSM: "Ask + MVR modules · View only · No source docs",
  Manager: "Admin logs read-only",
  Admin: "Full admin access",
  Auditor: "Admin logs read-only",
};
